import { IAcceptanceItem, ILCHttpResponse, ILegalDocs } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export type LegalDocsResponse = {
  legalDocs: ILegalDocs
  legalVersionsCurrent: ILegalDocs
  acceptances: IAcceptanceItem[]
}

export const legalDocsApi = createApi({
  reducerPath: 'legalDocsApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/legal-docs`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getLegalDocs: builder.query<LegalDocsResponse, void>({
      query: () => ({
        url: `/`,
        method: 'GET',
      }),
      transformResponse: (rawResult: ILCHttpResponse<LegalDocsResponse>, meta) => {
        return rawResult.data as LegalDocsResponse
      },
    }),
  }),
})

export const { useLazyGetLegalDocsQuery } = legalDocsApi
